import { Observable, catchError } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { HandleError, HttpErrorHandler, HttpUtility } from '@core/http';
import { API_BASE_URL, UrlConstants } from 'src/app/core';
import { SelectItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class UserSelectorService {
  handleError: HandleError;

  constructor(
    private httpUtility: HttpUtility,
    private httpErrorHandler: HttpErrorHandler,
    @Inject(API_BASE_URL) private apiBaseUrl: string
  ) {
    this.handleError = this.httpErrorHandler.createHandleError('LookupService');
  }

  getUsers(filters = ''): Observable<SelectItem[]> {
    return this.httpUtility.get<SelectItem[]>(`${this.apiBaseUrl}${UrlConstants.getUserSelectorSelectItems}?filter=${filters}`)
      .pipe(
        catchError(this.handleError('getUsers', []))
      );
  }

  getUsersIncludeUserId(filters = ''): Observable<SelectItem[]> {
    return this.httpUtility.get<SelectItem[]>(`${this.apiBaseUrl}${UrlConstants.getUserWithIdSelectorSelectItems}?filter=${filters}`)
      .pipe(
        catchError(this.handleError('getUsers', []))
      );
  }

}
